import React, { useEffect, useState } from "react";
import { Play, Pause } from "lucide-react";
import { Avatar } from "@mui/joy";
import { get_all_sell_Item, bulk_approved, toggle_item_active } from "../../reduxData/user/userAction";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { doc, onSnapshot, updateDoc } from "firebase/firestore";
import { db } from "../../config/firebase";
import CustomPagination from "../../components/CustomPagination";
import EmptyData from "../../components/EmptyData";
import { useSelector } from "react-redux";
import { formatInTimeZone } from "date-fns-tz";
import SellerProfile from "../../Modals/SellerProfile";
import BidPrice from "../Comman/BidPrice";
import Modal from "@mui/joy/Modal";
import ModalDialog from "@mui/joy/ModalDialog";
import DialogTitle from "@mui/joy/DialogTitle";
import DialogContent from "@mui/joy/DialogContent";
import { Box } from "@mui/joy";
import { useTranslation } from "react-i18next";
import { formatPrice } from "../../hooks/formatPrice";

const PRODUCT_STATUSES = [
  "PRODUCT_PENDING_APPROVAL",
  "PRODUCT_LIVE",
  "PRODUCT_REJECTED",
  "SOLD_OUT",
  "PRODUCT_ADMIN_PAUSED",
];

const PRODUCT_STATUS_ALIASES = {
  PRODUCT_PENDING_APPROVAL: "PRODUCT_PENDING_APPROVAL",
  PRODUCT_LIVE: "PRODUCT_LIVE",
  PRODUCT_REJECTED: "PRODUCT_REJECTED",
  PRODUCT_DRAFT: "PRODUCT_DRAFT",
  PRODUCT_ADMIN_PAUSED: "PRODUCT_ADMIN_PAUSED",
};

const normalizeProductStatus = (status) => {
  const normalizedStatus = typeof status === "string" ? status.trim().toUpperCase() : status;
  return PRODUCT_STATUS_ALIASES[normalizedStatus] || normalizedStatus;
};

const getProductStatusClass = (status) =>
  normalizeProductStatus(status)?.toLowerCase().replace(/[\s_]+/g, "-") || "";

const ItemListing = () => {
  const { t, i18n } = useTranslation();
  const { userPermissions } = useSelector((state) => state.auth);
  const { itemdata, itemTotal } = useSelector((state) => state.user);
  const [show, setShow] = useState(false);
  const [sellerData, setSellerData] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentTab, setCurrentTab] = useState("PRODUCT_PENDING_APPROVAL");
  const [perPage, setPerPage] = useState(10);
  const [reasonModal, setReasonModal] = useState(false);
  const [reason, setReason] = useState("");
  const [statusProduct, setStatusProduct] = useState(null);
  const [statusModalMode, setStatusModalMode] = useState(null);
  const [selectedPendingIds, setSelectedPendingIds] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { REACT_APP_IMAGE_URL } = process.env;
  const tabs = PRODUCT_STATUSES;
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const requestedTab = location.state?.productTab;
    if (PRODUCT_STATUSES.includes(requestedTab)) {
      setCurrentTab(requestedTab);
    }
  }, [location.state]);


  // call fetch data function 
  useEffect(() => {
    fetchData();
  }, [currentPage, perPage, currentTab]);

  //  fetch data function 
  const fetchData = async () => {
    try {
      if (PRODUCT_STATUSES.includes(currentTab)) {
        await get_all_sell_Item(dispatch, currentPage, perPage, currentTab);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  // manage real time data 
  useEffect(() => {
    const userRef = doc(db, "admin", "ADMIN");
    const getItem = onSnapshot(userRef, (snapshot) => {
      if (snapshot.exists()) {
        const newitem = snapshot.data();
        if (newitem.item_created) {
          handleUpdate();
        }
      }
    });
  }, []);

  // handle update real time 
  const handleUpdate = async () => {
    const userRef = doc(db, "admin", "ADMIN");
    await get_all_sell_Item(dispatch, 1, 10, currentTab);
    await updateDoc(userRef, { item_created: false });
  };

  useEffect(() => {
    // A fresh visit to Product Approval must always start on Pending.
    // `itemPage` was also used by User Management, so restoring it could set
    // this page to an invalid value such as "seller" and leave every tab inactive.
    localStorage.removeItem("itemPage");
    localStorage.removeItem("currentPage");
  }, []);


  // handle toggle select 
  const toggleSelectPending = (id) => {
    setSelectedPendingIds((prev) =>
      prev.includes(id)
        ? prev.filter((x) => x !== id)
        : [...prev, id]
    );
  };

  // handle select all 
  const toggleSelectAllPending = () => {
    if (!itemdata || !Array.isArray(itemdata)) return;
    const pendingIds = itemdata
      .filter((item) => normalizeProductStatus(item.status) === "PRODUCT_PENDING_APPROVAL")
      .map((item) => item.id || item._id); // adjust field name if needed
    const allSelected = pendingIds.every((id) => selectedPendingIds.includes(id));
    if (allSelected) {
      setSelectedPendingIds((prev) =>
        prev.filter((id) => !pendingIds.includes(id))
      );
    } else {
      setSelectedPendingIds((prev) => [
        ...new Set([...prev, ...pendingIds]),
      ]);
    }
  };

  // handle bulk approve item 
  const handleBulkApprove = async () => {
    if (selectedPendingIds.length === 0) return;
    try {
      setIsLoading(true);
      const bulkpayload = {
        item_ids: selectedPendingIds,
        status: "PRODUCT_LIVE",
      }
      let res = await bulk_approved(dispatch, bulkpayload, "PRODUCT_PENDING_APPROVAL");
      if (res?.data?.status === true) {
        await get_all_sell_Item(dispatch, 1, 10)
        setSelectedPendingIds([]);
        fetchData();
        setIsLoading(false)
      }
    } catch (err) {
      console.error("Bulk approve failed", err);
    }
  };

  // handle bulk rejected item 
  const handleBulkReject = async () => {
    if (selectedPendingIds.length === 0) return;
    try {
      setIsLoading(true);
      const bulkpayload = {
        item_ids: selectedPendingIds,
        status: "PRODUCT_REJECTED",
        reason: reason,
      }
      await bulk_approved(dispatch, bulkpayload)
      await get_all_sell_Item(dispatch, 1, 10, "PRODUCT_PENDING_APPROVAL")
      setSelectedPendingIds([]);
      fetchData();
      setReasonModal(false)
      setIsLoading(false)
    } catch (err) {
      console.error("Bulk approve failed", err);
    }
  };

  const closeStatusModal = () => {
    if (isLoading) return;
    setStatusProduct(null);
    setStatusModalMode(null);
    setReason("");
  };

  const requestStatusChange = (item) => {
    const isLive = normalizeProductStatus(item?.status) === "PRODUCT_LIVE";
    setStatusProduct(item);
    setStatusModalMode(isLive ? "pause" : "unpause");
    setReason("");
  };

  const handleStatusChange = async () => {
    const itemId = statusProduct?.id || statusProduct?._id;
    if (!itemId || !statusModalMode) return;
    if (statusModalMode === "pause" && reason.trim().length < 5) return;

    try {
      setIsLoading(true);
      const payload = {
        itemId: Number(itemId),
        isActive: statusModalMode === "unpause",
        ...(statusModalMode === "pause" ? { reason: reason.trim() } : {}),
      };
      const response = await toggle_item_active(dispatch, payload);
      if (response?.data?.status !== false && response?.data) {
        setStatusProduct(null);
        setStatusModalMode(null);
        setReason("");
        await fetchData();
      }
    } catch (error) {
      console.error("Product status update failed", error);
    } finally {
      setIsLoading(false);
    }
  };


  const isAllPendingSelected = () => {
    if (!itemdata || itemdata.length === 0) return false;
    const pendingItems = itemdata.filter((i) => normalizeProductStatus(i.status) === "PRODUCT_PENDING_APPROVAL");
    if (pendingItems.length === 0) return false;
    return pendingItems.every((i) => selectedPendingIds.includes(i.id || i._id));
  };

  const getFullImageUrl = (url) => {
    const checkExternalUrl = url ? (url?.startsWith("http") || url?.startsWith("https")) : false;
    const imageUrl = checkExternalUrl ? url : url ? `${REACT_APP_IMAGE_URL}${url}` : "";
    return imageUrl;
  };

  // Translate tab status label for the total count line
  const getTabLabel = (tab) => {
    return t(`itemListing.statuses.${normalizeProductStatus(tab)}`);
  };


  return (
    <div>
      <div className="container">
        <h3 className="mb-0 fw-600">{t("itemListing.pageTitle")}</h3>
        <div className="product-list-toolbar mt-4">
          <div>
            <ul className="list-inline mb-0 sorting-list">
              {tabs.map((tab) => (
                <li key={tab} className="list-inline-item mb-2 mb-md-0">
                  <Link
                    className={`text-decoration-none text-capitalize border rounded-pill px-3 py-2 ${currentTab === tab ? "active" : ""
                      }`}
                    onClick={() => {
                      setCurrentTab(tab);
                      setCurrentPage(1);
                    }}
                  >
                    {getTabLabel(tab)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>{" "}
        </div>
        <div className="col-lg-5">
          <h5 className="mt-4 fw-600 text-capitalize">
            {t("itemListing.totalLabel")}
            {" "}{getTabLabel(currentTab)}{" "}
            {/* {` ${currentTab === "PENDING" ? "PENDING"
              : currentTab === "REJECTED" ? "Rejected"
                : currentTab === "LIVE" ? "LIVE"
                  : "APPROVED"
              } `} */}
            {t("itemListing.totalAuctions")} (
            {PRODUCT_STATUSES.includes(currentTab) ? itemTotal : 0}
            )
            {/* Auctions (
            {`${(currentTab === "PENDING" || currentTab === "APPROVED" || currentTab === "REJECTED" || currentTab === "LIVE") ? itemTotal : 0}`}
            ) */}
          </h5>
        </div>

        {currentTab === "PRODUCT_PENDING_APPROVAL" && selectedPendingIds.length > 0 && (
          <div
            className="d-flex justify-content-between align-items-center p-3 mb-3"
            style={{
              background: "#e6f0ff",
              borderRadius: "8px",
              border: "1px solid #bbdefb",
            }}
          >
            <div>
              <strong>{selectedPendingIds.length}</strong> 
              {/* items selected */}{" "}
              {t("itemListing.selectedCount", { count: selectedPendingIds.length }).replace(
                `${selectedPendingIds.length} `,
                ""
              )}
            </div>

            <div className="d-flex gap-3">
              <button
                className="btn btn-success"
                onClick={handleBulkApprove}
                disabled={isLoading}
              >
                {t("itemListing.approveSelected")} {isLoading && t("itemListing.loading")}
              </button>
              <button
                className="btn btn-danger"
                onClick={() => setReasonModal(true)}
              >
                {t("itemListing.rejectSelected")}
              </button>

              <button
                className="btn btn-outline-secondary"
                onClick={() => setSelectedPendingIds([])}
              >
                {t("itemListing.clearSelection")}
              </button>
            </div>
          </div>
        )}

        <div className="table-responsive mt-4 product-list-table-wrap">
          <table className="table table-hover user-management-table product-list-table">
            <thead className="border-gray">
              <tr>
                {(userPermissions?.products?.edit && currentTab === "PRODUCT_PENDING_APPROVAL") && (
                  <th className="text-center" style={{ width: "60px" }}>
                    <input
                      type="checkbox"
                      checked={isAllPendingSelected()}
                      onChange={toggleSelectAllPending}
                    />
                  </th>
                )}
                <th>{t("itemListing.colSellerName")}</th>
                <th>{t("itemListing.colThumbnail")}</th>
                <th>{t("itemListing.colItemName")}</th>
                <th>{t("itemListing.colFinalSale")}</th>
                <th>{t("itemListing.colCategory")}</th>
                <th>{t("itemListing.colCondition")}</th>
                <th>{t("itemListing.colShopPrice")}</th>
                {currentTab === "PRODUCT_LIVE" && <th>{t("itemListing.colBidPrice")}</th>}
                {(currentTab !== "PRODUCT_PENDING_APPROVAL" && currentTab !== "PRODUCT_REJECTED") && <th>{t("itemListing.colApprovedDate")}</th>}
                <th>{t("itemListing.colStatus")}</th>
                {(currentTab === "PRODUCT_LIVE" || currentTab === "PRODUCT_ADMIN_PAUSED") &&
                  userPermissions?.products?.edit && <th className="text-center">{t("itemListing.colLiveStatus")}</th>}
                {userPermissions?.products?.view && <th className="text-center">{t("itemListing.colAction")}</th>}
              </tr>
            </thead>
            <tbody>
              {Array.isArray(itemdata) && itemdata?.length > 0 ? (
                itemdata?.map((item, index) => (
                  <React.Fragment key={index}>
                    <tr>
                      {userPermissions?.products?.edit && currentTab === "PRODUCT_PENDING_APPROVAL" && (
                        <td className="text-center">
                          {normalizeProductStatus(item.status) === "PRODUCT_PENDING_APPROVAL" ? (
                            <input
                              type="checkbox"
                              checked={selectedPendingIds.includes(item.id || item._id)}
                              onChange={() => toggleSelectPending(item.id || item._id)}
                            />
                          ) : (
                            <span className="text-muted">—</span>
                          )}
                        </td>
                      )}

                      <td>
                        <div className={item?.usersdata ? 'w-fit-content cursor-pointer hover-underline' : ''}
                          onClick={() => {
                            setSellerData(item?.usersdata || item?.seller);
                            setShow(true);
                          }}>
                          {item?.usersdata?.user_name || item?.seller?.user_name}
                        </div>
                      </td>
                      <td>
                        {item?.variant_auction !== null ?
                          <Avatar
                            variant="soft"
                            src={getFullImageUrl(item?.origin == 'manual' ? item?.variants[0]?.images[0] || item?.variant_auction[0]?.images[0] : item?.variants[0]?.images[0] || item?.variant_auction[0]?.images[0])}
                            alt={`Item Thumbnail ${index + 1}`}
                          /> : 'N/A'}
                      </td>
                      <td className="product-list-title" title={item?.title}><span>{item?.title}</span></td>
                      <td>{item?.include_in_final_sale == false ? "NO" : "YES"}</td>
                      <td>{item?.category_name || t("itemListing.naFallback")}</td>
                      <td>{item?.condition || t("itemListing.naFallback")}</td>
                      <td>
                        <span>{formatPrice(item?.original_retail_price, i18n)}</span>
                      </td>
                      {currentTab === "PRODUCT_LIVE" && <td><BidPrice id={item?.id} /></td>}
                      {(currentTab !== "PRODUCT_PENDING_APPROVAL" && currentTab !== "PRODUCT_REJECTED") && <td>
                        {item?.created_at
                          ? formatInTimeZone(
                            new Date(item.created_at),
                            "UTC",
                            "MM/dd/yyyy / hh:mm a"
                          )
                          : t("itemListing.naFallback")}
                      </td>}
                      <td>
                        <div className={`status-badge ${getProductStatusClass(item?.status)}`}>
                          <span>{getTabLabel(item?.status)}</span>
                        </div>
                      </td>
                      {(currentTab === "PRODUCT_LIVE" || currentTab === "PRODUCT_ADMIN_PAUSED") &&
                        userPermissions?.products?.edit && (
                          <td className="text-center">
                            <button
                              type="button"
                              className={`product-live-pill ${normalizeProductStatus(item?.status) === "PRODUCT_LIVE" ? "live" : "paused"}`}
                              disabled={isLoading}
                              onClick={() => requestStatusChange(item)}
                              aria-label={t("itemListing.toggleLiveStatus", { title: item?.title })}
                            >
                              <span className="product-live-pill-icon">
                                {normalizeProductStatus(item?.status) === "PRODUCT_LIVE"
                                  ? <Play size={10} fill="#fff" color="#fff" />
                                  : <Pause size={10} fill="#fff" color="#fff" />}
                              </span>
                              {normalizeProductStatus(item?.status) === "PRODUCT_LIVE"
                                ? t("itemListing.pillLive")
                                : t("itemListing.pillPaused")}
                            </button>
                          </td>
                        )}
                      {userPermissions?.products?.view && <td className="text-center">
                        <button
                          type="button"
                          className="product-view-button"
                          onClick={() => {
                            if (!item?.slug) return;
                            navigate(`/item-details/${item?.slug}`, {
                              state: { productTab: currentTab },
                            });
                          }}
                        >
                          {t("itemListing.viewButton")}
                        </button>
                      </td>}
                    </tr>
                  </React.Fragment>
                ))
              ) : (<EmptyData />)}
            </tbody>
          </table>
        </div>
      </div>

      <div className="mt-3">
        {itemTotal > 0 && (
          <CustomPagination
            total={itemTotal}
            onPageChange={(page, perPage) => {
              get_all_sell_Item(dispatch, page, perPage, currentTab);
            }}
          />
        )}
      </div>

      <SellerProfile
        show={show}
        handleClose={() => {
          setSellerData(null);
          setShow(false);
        }}
        seller={sellerData}
      />
      <Modal open={reasonModal} onClose={() => setReasonModal(false)}>
        <ModalDialog>
          <DialogTitle>{t("itemListing.rejectModalTitle")}</DialogTitle>
          <DialogContent>
            <div className="reject-reason-container">
              <label htmlFor="reason" className="reject-reason-label">
                 {t("itemListing.rejectReasonLabel")}
              </label>
              <textarea
                name="reason"
                id="reason"
                className="reject-reason-textarea"
                placeholder={t("itemListing.rejectReasonPlaceholder")}
                rows="5"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
              />
            </div>
          </DialogContent>
          <Box sx={{ p: 2 }}>
            <div className='d-flex gap-2 justify-content-end'>
              <button className='model-no-btn' onClick={() => setReasonModal(false)}> {t("itemListing.rejectCancelButton")}</button>
              <button
                className={`model-yes-btn ${!reason.trim() && 'modal-yes-btn-disable'}`}
                onClick={handleBulkReject}
                disabled={!reason.trim() || isLoading}
              >
                {t("itemListing.rejectConfirmButton")}{" "}
                {isLoading && t("itemListing.loading")}
              </button>
            </div>
          </Box>
        </ModalDialog>
      </Modal>
      <Modal open={Boolean(statusModalMode)} onClose={closeStatusModal}>
        <ModalDialog>
          <DialogTitle>
            {statusModalMode === "pause"
              ? t("itemListing.pauseModalTitle")
              : t("itemListing.unpauseModalTitle")}
          </DialogTitle>
          <DialogContent>
            {statusModalMode === "pause" ? (
              <div className="reject-reason-container">
                <label htmlFor="pause-reason" className="reject-reason-label">
                  {t("itemListing.pauseReasonLabel")}
                </label>
                <textarea
                  name="pause-reason"
                  id="pause-reason"
                  className="reject-reason-textarea"
                  placeholder={t("itemListing.pauseReasonPlaceholder")}
                  rows="5"
                  value={reason}
                  onChange={(event) => setReason(event.target.value)}
                  minLength={5}
                  maxLength={500}
                  autoFocus
                />
                <small className={reason.trim().length > 0 && reason.trim().length < 5 ? "text-danger" : "text-muted"}>
                  {reason.trim().length > 0 && reason.trim().length < 5
                    ? t("itemListing.pauseReasonMinLength")
                    : `${reason.length}/500`}
                </small>
              </div>
            ) : (
              <p className="mb-0">
                {t("itemListing.unpauseConfirmation", { title: statusProduct?.title })}
              </p>
            )}
          </DialogContent>
          <Box sx={{ p: 2 }}>
            <div className="d-flex gap-2 justify-content-end">
              <button className="model-no-btn" onClick={closeStatusModal} disabled={isLoading}>
                {t("itemListing.rejectCancelButton")}
              </button>
              <button
                className={`model-yes-btn ${statusModalMode === "pause" && reason.trim().length < 5 ? "modal-yes-btn-disable" : ""}`}
                onClick={handleStatusChange}
                disabled={isLoading || (statusModalMode === "pause" && reason.trim().length < 5)}
              >
                {statusModalMode === "pause"
                  ? t("itemListing.pauseConfirmButton")
                  : t("itemListing.unpauseConfirmButton")}
                {isLoading && ` ${t("itemListing.loading")}`}
              </button>
            </div>
          </Box>
        </ModalDialog>
      </Modal>
    </div>
  );
};

export default ItemListing;
